import React from "react";
import Avatar from "@mui/material/Avatar";
import "../scss/giftsuccess.scss";
import { useNavigate } from "react-router";

const Giftsuccess = ({ setConfirmModal, confirmModal, handleConfirm }) => {
  const navigate = useNavigate();

  const closeFirstModal = () => {
    setConfirmModal(false);
  };

  const handleView = () => {
    navigate("/Transcation");
  };

  return (
    <>
      {confirmModal && (
        <div className="modal gift-success !z-[1027]">
          <div className="modal-content">
            <div className="modal">
              <div className="modal-dialog">
                <div className="modal-content sucessful-card-modal">
                  <div className="modal-header d-flex justify-content-end align-items-end w-100">
                    <button
                      type="button"
                      className="close-btn"
                      onClick={closeFirstModal}
                      style={{
                        background: "#313131",
                        color: "#FFFFFF",
                        padding: "1px",
                      }}
                    >
                      <img src="img/close-icon.png" alt="" />
                    </button>
                  </div>
                  <div className="modal-body text-white text-center d-flex justify-content-center align-items-center flex-col">
                    <img src="/img/righttick.svg" className="mb-5"/>
                    <p className="h4 text-white mb-5">Transaction Successful</p>
                  </div>
                  <div className="modal-footer  d-flex ">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="view-btn text-center">
                          <button onClick={handleView} className="mt-2.5">
                            View Transactions
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="btn-done text-center ">
                          <button className="mt-2.5 " onClick={handleConfirm}>
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="view-btn" >
                          <button className="" onClick={handleView}>
                            View Transactions
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="done-btn">
                          <button
                            className=""
                            onClick={handleConfirm}
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Giftsuccess;
